import type { PlcManufacturerCodeLibrary } from "./types";

export const abbCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "abb",
  manufacturer_name: "ABB",
  codes: [
    {
      id: "abb-ac500s-e2-init-profisafe",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E2 / 1..4 / 255 / 30 / 1 / 2",
      code_type: "AC500 Diagnosis",
      title_ar: "Internal PROFIsafe initialization error",
      description_ar: "خطأ داخلي بتهيئة PROFIsafe داخل SM560-S Safety CPU.",
      symptoms: ["Safety CPU يسجل E2", "تشغيل safety ما يكتمل"],
      causes: ["خطأ داخلي بتهيئة PROFIsafe"],
      checks: [
        {
          step: 1,
          action: "اعرض التشخيص باستخدام diagshow all.",
          expected: "ماكو Error فعال.",
          faulty: "نفس tuple يبقى ظاهر.",
        }
      ],
      solutions: ["Restart للـSafety PLC حسب إجراء المصنع.", "إذا استمر، استبدال Safety PLC والتواصل ويا ABB support."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.1: Internal PROFIsafe initialization error",
      keywords: ["ABB", "AC500-S", "PROFIsafe", "E2"],
    },
    {
      id: "abb-ac500s-e2-profisafe",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E2 / 1..4 / 255 / 30 / 2 / 2",
      code_type: "AC500 Diagnosis",
      title_ar: "Internal PROFIsafe error",
      description_ar: "خطأ PROFIsafe داخلي بالـSafety CPU.",
      symptoms: ["Safety CPU يسجل E2"],
      causes: ["Internal PROFIsafe error"],
      checks: [
        {
          step: 1,
          action: "استخدم diagshow all وسجل التشخيص قبل Reset.",
          expected: "ماكو خطأ فعال.",
          faulty: "الخطأ يبقى أو يرجع.",
        }
      ],
      solutions: ["Restart حسب تعليمات ABB.", "إذا استمر، تواصل ويا ABB واستبدل Safety PLC حسب التشخيص."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.1: Internal PROFIsafe error",
      keywords: ["ABB", "AC500-S", "PROFIsafe"],
    },
    {
      id: "abb-ac500s-e3-profisafe-comm",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E3 / 14 / 1..10 / 31 / 31 / 20",
      code_type: "Safety I/O Diagnosis",
      title_ar: "PROFIsafe communication error",
      description_ar: "خطأ اتصال PROFIsafe بوحدة Safety I/O.",
      symptoms: ["Safety I/O يدخل error", "اتصال safety ينقطع"],
      causes: ["خطأ PROFIsafe communication"],
      checks: [
        {
          step: 1,
          action: "افحص شبكة PROFIsafe والتغذية والعناوين.",
          expected: "الاتصال ثابت.",
          faulty: "الخطأ يرجع بنفس الموديول.",
        }
      ],
      solutions: ["Restart للـI/O module حسب الدليل.", "إذا استمر، راجع الشبكة وتواصل ويا ABB support."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.6: Error 20 PROFIsafe communication error",
      keywords: ["ABB", "AC500-S", "E3", "20"],
    },
    {
      id: "abb-ac500s-e3-watchdog",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E3 / 14 / 1..10 / 31 / 31 / 25",
      code_type: "Safety I/O Diagnosis",
      title_ar: "PROFIsafe watchdog timed out",
      description_ar: "انتهى زمن PROFIsafe watchdog بدون اتصال صالح.",
      symptoms: ["Safety connection يفصل", "Error 25"],
      causes: ["تأخير أو فقدان اتصال PROFIsafe", "Watchdog time غير مناسب للتطبيق"],
      checks: [
        {
          step: 1,
          action: "افحص جودة الشبكة والوقت المضبوط.",
          expected: "الاتصال يكتمل ضمن watchdog.",
          faulty: "يتكرر timeout.",
        }
      ],
      solutions: ["عالج سبب تأخير الشبكة أولاً.", "زيادة watchdog فقط حسب تقييم وتصميم السلامة وتعليمات ABB."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.6: Error 25 PROFIsafe watchdog timed out",
      keywords: ["ABB", "AC500-S", "watchdog", "25"],
    },
    {
      id: "abb-ac500s-e3-vhigh",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E3 / 14 / 1..10 / 31 / 31 / 10",
      code_type: "Safety I/O Diagnosis",
      title_ar: "Process voltage too high",
      description_ar: "فولت تغذية العملية أعلى من المطلوب بوحدة Safety I/O.",
      symptoms: ["Error 10", "Safety I/O fault"],
      causes: ["Process voltage عالي"],
      checks: [
        {
          step: 1,
          action: "قِس فولت process supply بمعدة مناسبة ومن شخص مؤهل.",
          expected: "الفولت ضمن مواصفة الموديول.",
          faulty: "الفولت أعلى من المجال.",
        }
      ],
      solutions: ["صحح مصدر التغذية قبل إعادة الخدمة."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.6: Error 10 Process voltage too high",
      keywords: ["ABB", "AC500-S", "voltage", "10"],
    },
    {
      id: "abb-ac500s-e3-vlow",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E3 / 14 / 1..10 / 31 / 31 / 11",
      code_type: "Safety I/O Diagnosis",
      title_ar: "Process voltage too low",
      description_ar: "فولت تغذية العملية أوطى من المطلوب.",
      symptoms: ["Error 11", "Safety I/O fault"],
      causes: ["Process voltage واطي", "هبوط جهد أو تغذية ضعيفة"],
      checks: [
        {
          step: 1,
          action: "افحص فولت process supply تحت الحمل.",
          expected: "ضمن المواصفة.",
          faulty: "أوطى من المجال المسموح.",
        }
      ],
      solutions: ["صحح مصدر التغذية والربطات."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.6: Error 11 Process voltage too low",
      keywords: ["ABB", "AC500-S", "voltage", "11"],
    },
    {
      id: "abb-ac500s-e4-config",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E4 / 1 or 9 / 255 / 30 / 2 / 26",
      code_type: "AC500 Diagnosis",
      title_ar: "No or wrong configuration data from PM5x",
      description_ar: "ماكو configuration data صحيحة من PM5x، لذلك RUN مو ممكن.",
      symptoms: ["Safety PLC ما يدخل RUN", "E4 configuration error"],
      causes: ["Boot project غلط أو مفقود على PM5x"],
      checks: [
        {
          step: 1,
          action: "راجع boot project والـconfiguration.",
          expected: "Configuration صحيحة ومتاحة.",
          faulty: "E4 يبقى فعال وRUN مو ممكن.",
        }
      ],
      solutions: ["أنشئ boot project صحيح على PM5x."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.1: No or wrong configuration data from PM5x",
      keywords: ["ABB", "AC500-S", "E4", "configuration"],
    },
    {
      id: "abb-ac500s-e4-crc",
      manufacturer_id: "abb",
      series_id: "abb-ac500-s",
      model: null,
      code: "E4 / 1 or 9 / 255 / 30 / 1 / 19",
      code_type: "AC500 Diagnosis",
      title_ar: "CRC error boot project",
      description_ar: "الـSafety CPU اكتشف CRC error بالـboot project.",
      symptoms: ["E4", "Boot project ما يمر تحقق"],
      causes: ["Boot project corrupted أو CRC غير صحيح"],
      checks: [
        {
          step: 1,
          action: "راجع/أنشئ boot project جديد حسب ABB.",
          expected: "الـproject يمر تحقق بدون CRC error.",
          faulty: "E4 Error 19 يرجع.",
        }
      ],
      solutions: ["أنشئ boot project جديد وأعد تشغيل Safety PLC حسب تعليمات ABB."],
      severity: "حرجة",
      source_title: "ABB AC500-S Safety User Manual",
      source_section: "Table 3.1: CRC error boot project",
      keywords: ["ABB", "AC500-S", "CRC", "19"],
    },
  ],
};
